import React, { useState } from "react";
import { Card, Flex, Space } from "antd";
import { DeleteOutlined, KeyOutlined, RightOutlined } from "@ant-design/icons";
import { useThemeContext } from "../../../context/ThemeContext";
import EditProfile from "../../../components/Settings/Security/EditProfile";
import DeleteAccount from "../../../components/Settings/Security/DeleteAccount";
import Emergency911 from "../Emergency911";
import SettingsSidebarHeader from "../../../components/common/SettingsSidebarHeader";
import GradientButton from "../../../components/common/UI/GradientButton";
import "./index.scss";

const options = [
  {
    id: "1",
    name: "Edit Profile",
    number: "+971345678",
    icon: "Number",
  },
  {
    id: "2",
    name: "Account Deletion",
    icon: "laptop",
  },
  {
    id: "3",
    name: "Emergency 911",
    number: "+971345678",
    icon: "schedule",
  },
];

interface SecurityProps {
  handleBackToPrevious: () => void;
}

const Security: React.FC<SecurityProps> = ({ handleBackToPrevious }) => {
  const [currentScreen, setCurrentScreen] = useState("security");
  const { theme } = useThemeContext();

  const getScreenBasedOnItem = (item: any) => {
    if (item.id === "1") {
      return "update-profile-photo";
    } else if (item.id === "2") {
      return "account-deletion";
    } else if (item.id === "3") {
      return "emergency-911";
    } else {
      return "security";
    }
  };

  const handleNextScreen = (screen: string) => {
    setCurrentScreen(screen);
  };

  const handleBackToSecurity = () => {
    setCurrentScreen("security");
  };

  const getIconComponent = (iconName: string) => {
    switch (iconName) {
      case "Number":
        return (
          <img
            src={`/assets/icons/${theme}/update-profile.png`}
            width={20}
            height={20}
          />
        );
      case "laptop":
        return (
          <DeleteOutlined
            style={{
              fontSize: "18px",
              color: theme === "dark" ? "black" : "white",
            }}
          />
        );
      case "schedule":
        return (
          <img
            src={`/assets/icons/${theme}/police.png`}
            width={20}
            height={20}
          />
        );

      default:
        return <KeyOutlined style={{ fontSize: "18px" }} />;
    }
  };

  return (
    <>
      {currentScreen === "security" && (
        <div className="security-settings-container">
          <SettingsSidebarHeader
            title="Security"
            handleBackClick={handleBackToPrevious}
          />

          <div className="options-container">
            {options.map((item) => (
              <Card
                key={item.id}
                onClick={() => handleNextScreen(getScreenBasedOnItem(item))}
                className="option-card"
                bordered={false}
                styles={{ body: { padding: "6px 12px" } }}
              >
                <Flex align="center" justify="space-between" gap={10}>
                  <Space>
                    <GradientButton className="option-icon">
                      {getIconComponent(item.icon)}
                    </GradientButton>
                    <h6 className="option-title">{item.name}</h6>
                  </Space>
                  <RightOutlined />
                </Flex>
              </Card>
            ))}
          </div>
        </div>
      )}

      {currentScreen === "update-profile-photo" && (
        <EditProfile handleBackToPrevious={handleBackToSecurity} />
      )}

      {currentScreen === "account-deletion" && (
        <DeleteAccount handleBackToPrevious={handleBackToSecurity} />
      )}

      {currentScreen === "emergency-911" && (
        <Emergency911 handleBackToPrevious={handleBackToSecurity} />
      )}
    </>
  );
};

export default Security;
